module.exports = __webpack_public_path__ + "media/images/xpass/studio-loader-2-d095e61b0b38bc39604ee3bed53f18a3.svg";